"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
/**
 * Grabs access token from carvana cookie
 *
 * @example
 * import getCookie from '@carvana/futilities/getCookie';
 * getAccessToken()
 * () => 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyIsImtpZCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyJ9.eyJpc3MiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkiLCJhdWQiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkvcmVzb3VyY2VzIiwiZXhwIjoxNTYzNDAxMDk4LCJuYmYiOjE1NjM0MDA3OTgsImNsaWVudF9pZCI6IkNhcnZhbmFDb21EZWxlZ2F0aW9uIiwic2NvcGUiOiJjYXJ2YW5hX2NvbSIsInN1YiI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImF1dGhfdGltZSI6MTU2MzQwMDc5OCwiaWRwIjoiaWRzcnYiLCJyb2xlIjpbImFkbWluIiwiY3VzdG9tZXJzZXJ2aWNlIiwiZGV2ZWxvcGVyIiwiRW5naW5lZXJpbmciLCJpbXBlcnNvbmF0ZSIsIkltcGVyc29uYXRlVXNlciIsIlByZS1GaSIsIlFDVGVjaCIsIlFDVGVjaExlYWQiLCJ1c2VyIl0sIm5hbWUiOiJ0eWxlci5jaGVzd2lja0BjYXJ2YW5hLmNvbSIsImlzX2ltcGVyc29uYXRpbmciOiJGYWxzZSIsImltcGVyc29uYXRpbmdfdXNlciI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImFtciI6WyJ0cnVzdGVkIl19.A6KJ1lhhgSvdomZ81-QUBJTpzF2JAkBgg49eoYjPj49Pa3dUWbUruQBz8TMNLOHTJCzyfEbK8AUF91bOOuNrGZqZXosbmiRRLF_iootilMLnAQ_28Na9UPDgy0-sOz0ujAGV3XU4LkYiaM2Q4fH1QJ55qX6QuAUJklErt2576c3zrwt91QdP3xw-gWyUx4Bo30ba0iVByZQgeaf4bnrXVMWN9smdQV0jMNAJ1tGW85TEWA_aU7E--nC5E0e57n3iK-jPwqInJLCWcR4KgeNjWuyp3gWONMGjd1E6eK2EYrInY976d1Sp18lS7gl_JAj0bdkD0r5MqfWkE34EYfhyhQ'
 */
var getAccessToken = function () {
    var cookie = index_1.getCookie('CVAccessToken');
    try {
        return cookie.access_token;
    }
    catch (err) {
        return null;
    }
};
exports.default = getAccessToken;
//# sourceMappingURL=getAccessToken.js.map